import { gql } from "@apollo/client"

export default gql`
    mutation createAudio($audioInput: CreateAudioInput) {
        createAudio(createAudioInput: $audioInput) {
            fileName
            size
            binaryData
        }
    }
`
